const DEFAULT_SUBMIT_MESSAGE =
  "<h3 style='display: flex; justify-content: center; align-items: center;'>Thank you for submitting your form.</h3>";

function mapChildFormElements(mapElementData) {
  if (!mapElementData) return [];
  return mapElementData?.map((elementItem) => {
    const multipleJsonData = elementItem?.options
      ? JSON.parse(elementItem?.options)
      : null;
    let optionsData = null;
    let rowOptionData = null;
    let columnOptionData = null;
    let otherDisplayValueOptions = null;
    let otherDataValueOptions = null;
    if (elementItem.type === "select") {
      optionsData = multipleJsonData?.map((option) => option?.label);
    } else if (elementItem.type === "multiple_choice_grid") {
      rowOptionData = multipleJsonData?.rows || [];
      columnOptionData = multipleJsonData?.columns || [];
    } else if (
      elementItem.type === "checkbox" ||
      elementItem.type === "radio"
    ) {
      optionsData = multipleJsonData;
    } else if (elementItem.type === "scale") {
      otherDisplayValueOptions = multipleJsonData?.display_value || [];
      otherDataValueOptions = multipleJsonData?.data_value || [];
    }
    const element = {
      id: elementItem?.id,
      labelName: elementItem?.label,
      keyName: elementItem?.key,
      placeholder: elementItem?.place_holder,
      order: elementItem?.order?.toString(),
      formElementType: elementItem?.type?.toLowerCase(),
      required: elementItem?.required,
      statusField: elementItem?.status?.toLowerCase(),
      optionsData: optionsData,
      rowOptionData: rowOptionData,
      columnOptionData: columnOptionData,
      otherDisplayValueOptions: otherDisplayValueOptions,
      otherDataValueOptions: otherDataValueOptions,
      parent_id: elementItem?.parent_id,
      ...(elementItem?.parent_value
        ? { parent_value: elementItem?.parent_value }
        : {}),
      ...(elementItem?.options
        ? { options: JSON.parse(elementItem?.options) }
        : {}),
      ...(elementItem?.elements?.length
        ? { elements: mapChildFormElements(elementItem.elements) }
        : {}),
    };
    return element;
  });
}

function mapTopLevelFormElements(formElements) {
  return formElements?.map((item) => {
    const multipleJsonData = item?.options ? JSON.parse(item?.options) : null;
    let optionsData = null;
    let rowOptionData = null;
    let columnOptionData = null;
    let otherDisplayValueOptions = null;
    let otherDataValueOptions = null;
    if (item.type === "select") {
      optionsData = multipleJsonData?.map((option) => option?.label);
    } else if (item.type === "multiple_choice_grid") {
      rowOptionData = multipleJsonData?.rows || [];
      columnOptionData = multipleJsonData?.columns || [];
    } else if (item.type === "checkbox" || item.type === "radio") {
      optionsData = multipleJsonData;
    } else if (item.type === "scale") {
      otherDisplayValueOptions = multipleJsonData?.display_value || [];
      otherDataValueOptions = multipleJsonData?.data_value || [];
    } else {
      optionsData = multipleJsonData;
    }
    const elements = {
      id: item?.id,
      keyName: item?.key,
      labelName: item?.label,
      order: item?.order?.toString(),
      statusField: item?.status,
      placeholder: item?.place_holder,
      required: item?.required,
      formElementType: item?.type?.toLowerCase(),
      optionsData: optionsData,
      options: optionsData,
      rowOptionData: rowOptionData,
      columnOptionData: columnOptionData,
      otherDisplayValueOptions: otherDisplayValueOptions,
      otherDataValueOptions: otherDataValueOptions,
      parent_id: item?.parent_id,
      ...(item?.elements?.length
        ? { elements: mapChildFormElements(item?.elements) }
        : {}),
    };
    return elements;
  });
}

export function buildStatePatchFromFormDetails(getFormDetailsData) {
  const formElementData = mapTopLevelFormElements(
    getFormDetailsData?.form_elements
  );
  return {
    saveID: formElementData,
    savedData: formElementData,
    name: getFormDetailsData?.name || "",
    description: getFormDetailsData?.description || "",
    emails: getFormDetailsData?.response_email_to?.split(",") ?? [],
    responseNotification: Boolean(getFormDetailsData?.response_email),
    submit_message:
      getFormDetailsData?.submit_message || DEFAULT_SUBMIT_MESSAGE,
    status: getFormDetailsData?.status?.toLowerCase() || "",
    is_public:
      +getFormDetailsData?.is_public === 0
        ? "private"
        : getFormDetailsData?.is_public === 1
        ? "shared"
        : "",
    accessLevel: getFormDetailsData?.access_level_id,
    email_displayed: getFormDetailsData?.email_displayed,
    email_required: getFormDetailsData?.email_required,
  };
}
